const FIELD_TYPE_LABELS: Record<string, string> = {
  Address: 'Address',
  ShortText: 'Short Text',
  LongText: 'Long Text',
  Number: 'Number',
  Date: 'Date',
  Email: 'Email',
  Phone: 'Phone',
  Dropdown: 'Dropdown',
  MultipleChoice: 'Multiple Choice',
  Checkbox: 'Checkbox',
  Quiz: 'Quiz',
  Attachment: 'Attachment',
  Signature: 'Signature',
};

const stem = (input: string): string =>
  input
    .replace(/^VOLUNTEER_/, '')
    .replace(/^Form/, '')
    .replace(/TaskFieldType$/, '')
    .replace(/TaskField$/, '')
    .replace(/Type$/, '');

export const taskFieldTypeLabel = (input?: string | null): string => {
  if (!input) {
    return '';
  }

  return FIELD_TYPE_LABELS[stem(input)] ?? '';
};
